import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Latest Trends We Follow in <span>Android App Development</span>
            </h2>
            <p>
              Believing ourselves as a tech-revolutionary, we aim to grip on the
              latest trends in the Android app development sector keeping our
              clients way ahead of the competition. It also allows us to create
              something extraordinary that brings a great deal of value to the
              end-users. Below here are the latest tech-based trends that we
              utilize in our custom Android app development services:
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>
                  AI <br />
                  Development
                </h4>
                <p>
                  Leveraging advanced AI algorithms to create intelligent,
                  personalized experiences for users.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Augmented & Virtual <br />
                  Reality
                </h4>
                <p>
                  Immerse users in captivating virtual worlds and enhance
                  real-world interactions with AR and VR technology.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Machine <br />
                  Learning
                </h4>
                <p>
                  Utilizing the power of machine learning to analyze data,
                  predict user behavior, and improve app performance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  NFT <br />
                  Development
                </h4>
                <p>
                  Maximizing the potential of blockchain technology to create
                  unique digital assets and unlock new avenues of monetization.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
